import React, { useEffect, useState } from 'react';
import { getTimeInterval } from 'v2/timeIntervalCalculator';
import { getCategoryColor } from 'v2/generalAnnouncementFunctions';
import DetailsModal from './DetailsModal';
import { DeleteOutlined, EditOutlined, StarTwoTone } from '@ant-design/icons';
import { Button, message, Popconfirm, Popover, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import publishIcon from 'v2/Assets/dashboardIcons/announcementListIcons/publishIcon.svg';
import deleteIcon from 'v2/Assets/dashboardIcons/teacherDashboardIcons/deleteIcon.svg';
import moment from 'moment';
import { TrackerHandler } from 'v2/MixpanelTracking/Tracker';
import axiosInstance from 'config/axios';
import endpoints from 'v2/config/endpoints';

const ListCard = (props) => {
  const {
    id,
    category_name: category,
    title,
    content,
    created_at: date,
    is_flash_event,
    created_by_user_level,
  } = props.data;
  const { showTab, deleteAnnouncement, publishAnnouncement, btnLoading } = props;
  const [showModal, setShowModal] = useState(false);
  const [detailedData, setDetailedData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { is_superuser } = JSON.parse(localStorage.getItem('userDetails')) || {};
  // const is_superuser = false;
  const { user_level } = JSON.parse(localStorage.getItem('userDetails')) || {};
  // const user_level = 8;

  if (!props.data) {
    console.log('props.data is undefined');
    return null;
  }

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailedData(null);
  };

  const fetchAnnouncementDetails = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${endpoints.createAnnouncementV2.retrieveUpdateDeleteAnnouncement}`,
        {
          params: { announcement_id: id },
        }
      );
      if (response.data.status_code === 200) {
        setDetailedData(response.data.result);
        setShowModal(true);
      } else {
        message.error('Failed to fetch announcement details');
      }
    } catch (error) {
      console.error('Error fetching announcement details:', error);
      message.error('An error occurred while fetching announcement details');
    } finally {
      setLoading(false);
    }
  };

  const extractContent = (s) => {
    const span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };
  const getDuration = (date) => {
    let currentDate = moment(date).format('DD/MM/YYYY');
    if (currentDate === moment().format('DD/MM/YYYY')) {
      return 'Today';
    } else if (currentDate == moment().subtract(1, 'days').format('DD/MM/YYYY')) {
      return 'Yesterday';
    } else {
      return (
        <span>
          {currentDate} <br />
          {moment(date).format('LT')}
        </span>
      );
    }
  };

  return (
    <>
      <div
        className='row th-bg-grey py-3 th-14 th-fw-400'
        style={{
          borderLeft: `4px ${getCategoryColor(category)} solid`,
          borderRadius: ' 0px 4px 4px 0px',
          backgroundOpacity: 0.5,
        }}
      >
        <div className='col-md-2 col-4 text-uppercase th-fw-500 text-break pr-0 pr-md-1'>
          {category} {is_flash_event ? <StarTwoTone twoToneColor='#52c41a' /> : null}
        </div>
        <div
          className='col-md-2 col-5 text-truncate th-pointer'
          style={{ width: '10%' }}
          onClick={() => {
            if (showTab != 2) {
              TrackerHandler('announcement_view', { title });
              fetchAnnouncementDetails();
            }
          }}
        >
          <b>
            {extractContent(title).length > 25 ? (
              <Tooltip
                autoAdjustOverflow='false'
                placement='bottomLeft'
                title={extractContent(title)}
                overlayStyle={{ maxWidth: '40%', minWidth: '20%' }}
              >
                {extractContent(title)}
              </Tooltip>
            ) : (
              extractContent(title)
            )}
          </b>
        </div>
        <div
          className={`${
            [1, 3].includes(parseInt(showTab))
              ? [1, 8].includes(user_level) || is_superuser
                ? 'col-md-4'
                : 'col-md-6'
              : showTab == 2
              ? 'col-md-5'
              : 'col-md-6'
          } col-5 text-truncate th-pointer`}
          style={{ width: '95%' }}
          onClick={() => {
            TrackerHandler('announcement_view', { title });
            setShowModal(true);
          }}
        >
          {extractContent(content).length > 66 ? (
            <Tooltip
              autoAdjustOverflow='false'
              placement='bottomLeft'
              title={extractContent(content)}
              overlayStyle={{ maxWidth: '40%', minWidth: '20%' }}
            >
              {extractContent(content)}
            </Tooltip>
          ) : (
            extractContent(content)
          )}
        </div>
        {showTab != 2 ? (
          <div className={`col-md-2 col-3 px-2 px-md-4 th-grey text-right`}>
            <Tooltip
              autoAdjustOverflow='false'
              placement='bottomRight'
              title={getDuration(date)}
            >
              {' '}
              {getTimeInterval(date)}
            </Tooltip>
          </div>
        ) : null}
        {([1, 3].includes(parseInt(showTab)) &&
          ([1, 8].includes(user_level) || is_superuser)) ||
        showTab == 2 ? (
          <div
            className={`${
              showTab == 2 ? 'col-md-3' : 'col-md-2'
            } col-3 px-2 px-md-4 th-grey text-right`}
          >
            <div className='d-flex flex-row justify-content-end'>
              {showTab == 2 ? (
                //   {/* {props?.allowedPublishBranches?.length > 0 &&
                //   !props?.allowedPublishBranches?.includes(props?.data?.id[0])
                //     ? 'Verify'
                //     : 'Publish'} */}
                <Button
                  type='primary'
                  loading={btnLoading}
                  onClick={() => {
                    publishAnnouncement(id);
                  }}
                >
                  Publish
                </Button>
              ) : null}
              {showTab == 2 ||
              ([1, 3].includes(parseInt(showTab)) &&
                (is_superuser || [1].includes(user_level))) ? (
                <>
                  <Popconfirm
                    title='Sure to delete?'
                    onConfirm={(e) => deleteAnnouncement(props?.data?.id)}
                  >
                    {/* <DeleteOutlined
                      title='Delete'
                      style={{ margin: 10, cursor: 'pointer', color: '#1B4CCB' }}
                    /> */}
                    <Button
                      type='primary'
                      shape='circle'
                      className='ml-1'
                      icon={<DeleteOutlined title='Delete' />}
                    />
                  </Popconfirm>
                </>
              ) : null}
              {showTab == 2 ||
              ([1, 3].includes(parseInt(showTab)) &&
                (is_superuser || [1, 8].includes(user_level))) ? (
                <>
                  <Link
                    to={{
                      pathname: `/edit-announcement/${props?.data?.id}`,
                      state: { data: props?.data },
                    }}
                  >
                    {/* <EditOutlined
                      title='Edit'
                      style={{ margin: 10, cursor: 'pointer', color: '#1B4CCB' }}
                    /> */}
                    <Button
                      type='primary'
                      shape='circle'
                      className='ml-1'
                      icon={<EditOutlined title='Edit' />}
                    />
                  </Link>
                </>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      {showModal && detailedData && (
        <DetailsModal
          data={detailedData}
          show={showModal}
          showTab={showTab}
          setTab={props?.setTab}
          handleClose={handleCloseModal}
          allowedPublishBranches={props?.allowedPublishBranches}
        />
      )}
    </>
  );
};

export default ListCard;
